import ChipSelect from './ChipSelect';
import _ from 'lodash';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import clsx from 'clsx';
import { withFormsy } from 'formsy-react';
import React from 'react';
import Link from '@mui/material/Link';
import { EWidget } from 'enums';
import { NEGATIVE_OPTION_ALIAS } from 'kosmosConfig';
import { activityReferences } from 'euActivity/activities-ref';

function EuActivitySelectFormsy(props) {
  const [selectedOption, SetSelectedOption] = React.useState(null);
  const importedProps = _.pick(props, [
    'children',
    'classes',
    'className',
    'defaultValue',
    'disabled',
    'fullWidth',
    'id',
    'name',
    'onBlur',
    'onChange',
    'onFocus',
    'required',
    'textFieldProps',
    'variant',
    'options',
    'errorMessage',
    'color',
  ]);

  // An error message is returned only if the component is invalid
  const { description, errorMessage, value, options } = props;

  function changeValue(val) {
    props.setValue([
      {
        alias: val.alias,
        label: val.label,
      },
    ]);
    SetSelectedOption(val);
  }

  // inject label into values
  const reformatValues = () => {
    return (value || []).map((o) => ({ value: o.alias, label: o.label }));
  };

  const helperText = description;

  const renderFormHelperText = () => {
    const firstItem = Array.isArray(value) ? value[0] : value;
    const label = firstItem?.label;
    const alias = firstItem?.alias;
    if (alias && alias !== '' && alias !== NEGATIVE_OPTION_ALIAS) {
      const reference = activityReferences[alias] || '';
      return (
        <Link href={reference} underline="always" rel="noreferrer" target="_blank">
          Do No Significant Harm (DNSH) criteria reference: "{label}"
        </Link>
      );
    }
  };

  return (
    <FormControl
      error={Boolean((!props.isPristine && props.showRequired) || errorMessage)}
      className={clsx(
        props.className,
        props.showRequired ? 'required' : '',
        props.showError ? 'error' : null,
      )}
      variant={importedProps.variant}
    >
      <ChipSelect
        {...importedProps}
        placeholder={props.label}
        value={reformatValues()}
        onChange={changeValue}
        error={Boolean((!props.isPristine && props.showRequired) || errorMessage)}
      />
      {renderFormHelperText()}
    </FormControl>
  );
}

export default React.memo(withFormsy(EuActivitySelectFormsy));
